import { render, staticRenderFns } from "./itemfrm.vue?vue&type=template&id=83b3f5fe"
import script from "./itemfrm.vue?vue&type=script&lang=js"
export * from "./itemfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports